import { observer } from 'mobx-react-lite';
import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';
import { getEventQueueRowData } from '../../utils/get-event-queue-row-data';
import { TimeCell } from './common/time-cell';

export const TimeReceivedCell = observer(function TimeReceivedCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    return <TimeCell dateStr={getEventQueueRowData(data)?.timeReceived} />;
});
